import React__default from 'react';

/** partial svg element for star icon to take advantage of the of 'currentcolor' inheritance from the wrapping html element  */
var starSvgIcon = {
  size: 18,
  viewBox: '-3 -4 34 34',
  element: function element(props) {
    var id = props.id,
      fill = props.fill,
      strokeWidth = props.strokeWidth,
      strokeFill = props.strokeFill,
      filter = props.filter,
      secondaryColor = props.secondaryColor,
      disabled = props.disabled;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, typeof fill === 'number' && /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
      id: id,
      x1: "0",
      y1: "0",
      x2: "1",
      y2: "0"
    }, /*#__PURE__*/React__default.createElement("stop", {
      id: "stop1",
      offset: fill,
      stopColor: "currentcolor"
    }), /*#__PURE__*/React__default.createElement("stop", {
      id: "stop2",
      offset: fill,
      stopColor: secondaryColor
    }))), /*#__PURE__*/React__default.createElement("g", {
      stroke: "none",
      strokeWidth: strokeWidth ? strokeWidth : 1.5,
      fill: typeof fill === 'number' ? "url(#".concat(id, ")") : typeof fill === 'string' ? fill : '#FCFDFD',
      fillRule: "evenodd",
      filter: filter
    }, /*#__PURE__*/React__default.createElement("polygon", {
      points: "17.0509596 0 21.9436293 11.1598595 34.1019192 12.3501975 24.9674281 20.4376799 27.5891392 32.3332073 17.0509596 26.1717082 6.51277999 32.3332073 9.13449111 20.4376799 -3.55271368e-15 12.3501975 12.1582899 11.1598595",
      transform: "scale(0.8)",
      stroke: fill ? 'currentcolor' : strokeFill ? strokeFill : disabled ? '#ECEDEF' : '#737C85',
      strokeWidth: strokeWidth ? strokeWidth : 4
    })));
  }
};

export { starSvgIcon };
//# sourceMappingURL=star-svg-icon.esm.js.map
